export const CREATE_STRIPE_PAYMENT = "@APP.CREATE_STRIPE_PAYMENT";
export const SET_CLIENT_SECRET = "@APP.SET_CLIENT_SECRET";
export const UPDATE_PAYMENT = "@APP.UPDATE_PAYMENT";
export const GET_PAYMENTS = "@APP.GET_PAYMENTS";
export const GET_CONNECT_TO_STRIPE_LINK = "@APP.GET_CONNECT_TO_STRIPE_LINK";
export const CONFIRM_STRIPE_ACCOUNT = "@APP.CONFIRM_STRIPE_ACCOUNT";
export const CREATE_PAYOUT = "@APP.CREATE_PAYOUT";
export const REDIRECT_TO_STRIPE_ACCOUNT = "@APP.REDIRECT_TO_STRIPE_ACCOUNT";
